var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-card-mobile"},[_c('div',{staticClass:"wrapper-img"},[_vm._t("img"),_vm._t("meta")],2),_c('h5',{staticClass:"event-card-title"},[_vm._t("title")],2),_c('p',{staticClass:"event-card-date"},[_vm._t("date")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }